export default __webpack_public_path__ + "static/media/7-11civil3dwebinar.2963b37d.jpeg";